import React, { Component } from "react";
import _ from "lodash";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "../../assets/styles/bootstrap-table-extra.css";

class ChargesTable extends Component {
  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  reportFormat = (cell, row) => {
    const res =
      row.type === "header" ? (
        <span className={"charges-col"}>{cell}</span>
      ) : (
        cell
      );
    return res;
  };

  loadData = (props) => {
    const rows = [];
    if (props.recs !== undefined) {
      _.forEach(props.recs, (element, index) => {
        const reportCount = _.get(element, "ReportCount[0]", "0");
        if (parseInt(reportCount, 10) > 0) {
          const headerTotalCost = _.get(element, "TotalCost[0]", "");
          const headerCol = {
            actId: `act_${index}`,
            activity: _.get(element, "UserName[0]", ""),
            count: reportCount,
            price: "",
            cost: typeof headerTotalCost === "object" ? "" : headerTotalCost,
            type: "header",
          };
          rows.push(headerCol);
          const details = _.get(element, "detail");
          if (details) {
            _.forEach(details, (detail, subIndex) => {
              const totalCost = _.get(detail, "TotalCost[0]", "");
              const col = {
                actId: `det_${index}_${subIndex}`,
                activity: _.get(detail, "ReportName[0]", ""),
                count: _.get(detail, "ReportCount[0]", ""),
                price: _.get(detail, "Cost[0]", ""),
                cost: typeof totalCost === "object" ? "" : totalCost,
                type: "detail",
              };
              rows.push(col);
            });
          }
        } else {
          const headerTotalCost = _.get(element, "TotalCost[0]", "");
          const headerCol = {
            actId: `act_${index}`,
            activity: _.get(element, "UserName[0]", ""),
            count: reportCount,
            price: "",
            cost: typeof headerTotalCost === "object" ? "" : headerTotalCost,
            type: "header",
          };
          rows.push(headerCol);
        }
      });
    }

    const columns = [
      {
        dataField: "activity",
        text: "Activity",
        formatter: this.reportFormat,
        width: "70%",
        sort: true,
      },
      {
        dataField: "count",
        text: "Count",
        formatter: this.reportFormat,
        width: "10%",
        sort: true,
      },
      {
        dataField: "price",
        text: "Price",
        width: "10%",
        sort: true,
      },
      {
        dataField: "cost",
        text: "Cost",
        formatter: this.reportFormat,
        width: "10%",
        sort: true,
      },
    ];
    if (this.state === undefined) {
      this.state = { rows, columns };
    } else {
      this.setState({ rows, columns });
    }
  };

  render() {
    if (this.state !== null && this.state.columns.length > 0) {
      return (
        <BootstrapTable
          data={this.state.rows}
          keyField={"actId"}
          columns={this.state.columns}
          pagination={paginationFactory()}
          striped
          hover
        />
      );
    }
    return null;
  }
}

export default ChargesTable;



// WEBPACK FOOTER //
// ./src/components/myaccount/ChargesTable.js